module.exports = __webpack_public_path__ + "static/img/logo.fee1152a.svg";